import AddNote from './AddNote'

export default AddNote
